import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useCallback, useContext, useMemo, useReducer } from 'react';
function reducer(state, action) {
  switch (action.type) {
    case 'clear':
      if (!!state.range || !!state.type) {
        return {
          range: null,
          draftRange: null,
          type: null
        };
      }
      return state;
    case 'clearSelection':
      if (state.type === 'selection') {
        return _objectSpread(_objectSpread({}, state), {}, {
          range: null,
          type: null
        });
      }
      return state;
    case 'clearDraftSelection':
      if (state.type === 'selection') {
        return _objectSpread(_objectSpread({}, state), {}, {
          draftRange: null
        });
      }
      return state;
    case 'clearDraftHover':
      if (state.type === 'hover') {
        return _objectSpread(_objectSpread({}, state), {}, {
          draftRange: null
        });
      }
      return state;
    case 'clearHover':
      if (state.type === 'hover') {
        return {
          range: null,
          draftRange: null,
          type: null
        };
      }
      return state;
    case 'setSelection':
      if (state.range !== action.range || state.type !== 'selection') {
        return _objectSpread(_objectSpread({}, state), {}, {
          range: action.range,
          type: 'selection'
        });
      }
      return state;
    case 'setHover':
      if (state.range !== action.range || state.type !== 'hover') {
        return _objectSpread(_objectSpread({}, state), {}, {
          range: action.range,
          type: 'hover'
        });
      }
      return state;
    case 'setDraftSelection':
      if (state.draftRange !== action.draftRange || state.type !== 'selection') {
        return {
          range: null,
          draftRange: action.draftRange,
          type: null
        };
      }
      return state;
    case 'setDraftHover':
      if (state.draftRange !== action.draftRange || state.type !== 'hover') {
        return _objectSpread(_objectSpread({}, state), {}, {
          draftRange: action.draftRange
        });
      }
      return state;
  }
}
var AnnotationRangeStateContext = /*#__PURE__*/createContext({
  range: null,
  draftRange: null,
  type: null
});
var AnnotationRangeDispatchContext = /*#__PURE__*/createContext({
  clearRange: function clearRange() {},
  clearSelectionRange: function clearSelectionRange() {},
  clearDraftRange: function clearDraftRange() {},
  clearHoverRange: function clearHoverRange() {},
  setRange: function setRange() {},
  setDraftRange: function setDraftRange() {}
});
export var AnnotationRangeProvider = function AnnotationRangeProvider(_ref) {
  var children = _ref.children,
    allowCommentsOnMedia = _ref.allowCommentsOnMedia;
  var _useReducer = useReducer(reducer, {
      range: null,
      draftRange: null,
      type: null
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    _useReducer2$ = _useReducer2[0],
    range = _useReducer2$.range,
    draftRange = _useReducer2$.draftRange,
    type = _useReducer2$.type,
    dispatch = _useReducer2[1];
  var clearRange = useCallback(function () {
    return dispatch({
      type: 'clear'
    });
  }, []);
  var clearSelectionRange = useCallback(function () {
    return dispatch({
      type: 'clearSelection'
    });
  }, []);
  var clearDraftRange = useCallback(function (type) {
    if (type === 'hover') {
      dispatch({
        type: 'clearDraftHover'
      });
      return;
    }
    dispatch({
      type: 'clearDraftSelection'
    });
  }, []);
  var clearHoverRange = useCallback(function () {
    return dispatch({
      type: 'clearHover'
    });
  }, []);
  var setRange = useCallback(function (range) {
    return dispatch({
      type: 'setSelection',
      range: range
    });
  }, []);
  var setDraftRange = useCallback(function (range, type) {
    if (type === 'hover') {
      dispatch({
        type: 'setDraftHover',
        draftRange: range
      });
      return;
    }
    dispatch({
      type: 'setDraftSelection',
      draftRange: range
    });
  }, []);
  var setHoverTarget = useCallback(function (target) {
    // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
    var mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
    if (!mediaNode) {
      return;
    }
    var range = document.createRange();
    range.setStartBefore(mediaNode);
    range.setEndAfter(mediaNode);
    dispatch({
      type: 'setHover',
      range: range
    });
  }, []);
  var stateData = useMemo(function () {
    return {
      range: range,
      draftRange: draftRange,
      type: type
    };
  }, [range, draftRange, type]);
  var dispatchData = useMemo(function () {
    return {
      clearRange: clearRange,
      clearSelectionRange: clearSelectionRange,
      clearDraftRange: clearDraftRange,
      clearHoverRange: clearHoverRange,
      setRange: setRange,
      setDraftRange: setDraftRange,
      setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined
    };
  }, [allowCommentsOnMedia, clearRange, clearSelectionRange, clearDraftRange, clearHoverRange, setRange, setDraftRange, setHoverTarget]);
  return /*#__PURE__*/React.createElement(AnnotationRangeStateContext.Provider, {
    value: stateData
  }, /*#__PURE__*/React.createElement(AnnotationRangeDispatchContext.Provider, {
    value: dispatchData
  }, children));
};
export var useAnnotationRangeState = function useAnnotationRangeState() {
  return useContext(AnnotationRangeStateContext);
};
export var useAnnotationRangeDispatch = function useAnnotationRangeDispatch() {
  return useContext(AnnotationRangeDispatchContext);
};